import React from "react";
import { Table } from "semantic-ui-react";

export const concealedContent = (
  <Table className={"coverage-area-table"}>
    <Table.Body>
      <Table.Row>
        <Table.HeaderCell colSpan={2}>Concealed Weapons</Table.HeaderCell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Arkansas*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Florida*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Indiana*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Louisiana*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Maine</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>North Dakota*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tennessee</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Virginia*</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Row>
          <Table.Cell colSpan={2} className={"red-text"}>
            * Only historical data available
          </Table.Cell>
        </Table.Row>
      </Table.Row>
    </Table.Body>
  </Table>
);

export default concealedContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/Concealed.js